module.exports = __webpack_public_path__ + "static/media/delete.b20ea7fd.svg";